import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { apiService } from '../../../services/api';
import Sidebar from '../../../components/feature/Sidebar';

export default function SuperSeteResumo() {
  const location = useLocation();
  const navigate = useNavigate();
  const { numbers, generationId, ticketId } = location.state || {};
  const [salvo, setSalvo] = useState(false);
  const [confete, setConfete] = useState(false);

  if (!numbers || !Array.isArray(numbers)) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 text-white">
        <Sidebar />
        <div className="ml-72 p-8">
          <div className="text-center text-red-400">
            <h2 className="text-2xl font-bold mb-4">Erro</h2>
            <p>Nenhuma aposta encontrada. Por favor, faça sua aposta primeiro.</p>
            <button
              onClick={() => navigate('/super-sete')}
              className="mt-4 px-6 py-3 bg-gradient-to-r from-green-500 to-green-600 rounded-xl hover:shadow-lg transition-all"
            >
              Voltar para Super Sete
            </button>
          </div>
        </div>
      </div>
    );
  }

  const getTotalNumbers = () => {
    return numbers.reduce((total, col) => total + col.length, 0);
  };

  const getBetType = () => {
    if (getTotalNumbers() === 7) return 'Simples';
    if (getTotalNumbers() <= 14) return 'Múltipla (2 números/coluna)';
    return 'Múltipla (3 números/coluna)';
  };

  const getBetValue = () => {
    if (getTotalNumbers() === 7) return 'R$ 2,50';
    if (getTotalNumbers() <= 14) return 'R$ 5,00';
    return 'R$ 7,50';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 text-white">
      <Sidebar />
      
      <div className="ml-72 p-8">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold mb-2">Resumo da Aposta - Super Sete</h1>
            <p className="text-white/60 text-sm">Confira os números selecionados</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Left column - Bet info */}
            <div className="lg:col-span-1 space-y-6">
              <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6">
                <h3 className="text-xl font-bold mb-4">Informações da Aposta</h3>
                
                <div className="space-y-4">
                  <div className="flex justify-between items-center">
                    <span className="text-white/60">Total de números:</span>
                    <span className="font-bold text-cyan-400">{getTotalNumbers()} números</span>
                  </div>
                  
                  <div className="flex justify-between items-center">
                    <span className="text-white/60">Tipo de aposta:</span>
                    <span className="font-bold">{getBetType()}</span>
                  </div>
                  
                  <div className="flex justify-between items-center">
                    <span className="text-white/60">Valor da aposta:</span>
                    <span className="font-bold text-green-400">{getBetValue()}</span>
                  </div>

                  {ticketId && (
                    <div className="flex justify-between items-center">
                      <span className="text-white/60">ID do Ticket:</span>
                      <span className="font-mono text-sm">#{ticketId}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Action buttons */}
              <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6">
                <h3 className="text-lg font-bold mb-4">Próximos Passos</h3>
                
                <div className="space-y-3">
                  <div className="relative">
                    {confete && (
                      <div className="confetti-container-top">
                        {Array.from({ length: 96 }).map((_, i) => {
                          const colors = ['#10B981','#22D3EE','#3B82F6','#F59E0B','#EF4444','#14B8A6'];
                          const color = colors[Math.floor(Math.random() * colors.length)];
                          const delay = Math.floor(Math.random() * 300);
                          const duration = 850 + Math.floor(Math.random() * 850);
                          const timings = ['ease-out','cubic-bezier(0.25, 0.85, 0.35, 1)','cubic-bezier(0.2, 0.8, 0.2, 1)'];
                          const timing = timings[Math.floor(Math.random() * timings.length)];
                          const x2 = (Math.random() - 0.5) * 40;
                          const w = 3 + Math.floor(Math.random() * 3);
                          const h = 6 + Math.floor(Math.random() * 4);
                          const left = Math.random() * 100;
                          const topStart = -Math.floor(Math.random() * 10);
                          return (
                            <span
                              key={i}
                              className="confetti-piece confetti-piece--top"
                              style={{
                                left: `${left}%`,
                                top: `${topStart}px`,
                                backgroundColor: color,
                                animationDelay: `${delay}ms`,
                                animationDuration: `${duration}ms`,
                                animationTimingFunction: timing,
                                ['--dx2' as any]: `${x2}px`,
                                width: `${w}px`,
                                height: `${h}px`
                              }}
                            />
                          );
                        })}
                      </div>
                    )}
                    <button
                      onClick={async () => {
                        if (salvo) return;
                        if (!Array.isArray(numbers) || numbers.length !== 7) {
                          alert('Aposta inválida');
                          return;
                        }
                        const simple = numbers.map((col: number[]) => (Array.isArray(col) && col.length > 0 ? col[0] : 0));
                        try {
                          await apiService.createGame('super-sete', simple);
                          setSalvo(true);
                          setConfete(true);
                          setTimeout(() => setConfete(false), 1600);
                        } catch (e) {
                          alert('Falha ao salvar jogo');
                        }
                      }}
                      disabled={salvo}
                      className={`w-full px-6 py-3 text-base font-bold rounded-xl transition-all whitespace-nowrap cursor-pointer ${salvo ? 'bg-white/10 border border-white/20 text-white/60 animate-pop' : 'bg-gradient-to-r from-green-500 to-emerald-600 hover:shadow-lg'}`}
                    >
                      <i className={`${salvo ? 'ri-check-double-line' : 'ri-check-line'} mr-2`}></i>
                      {salvo ? 'Salvo!' : 'Vou jogar'}
                    </button>
                  </div>
                  <button
                    onClick={async () => {
                      if (!generationId) return;
                      try {
                        const blob = await apiService.getGenerationPdf(generationId);
                        const url = window.URL.createObjectURL(blob);
                        window.open(url, '_blank');
                        setTimeout(() => window.URL.revokeObjectURL(url), 60000);
                      } catch (e) {
                        console.error(e);
                        alert('Falha ao gerar PDF');
                      }
                    }}
                    className="w-full px-6 py-4 text-base font-bold bg-white text-green-600 border border-green-600 rounded-xl hover:bg-green-50 transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-file-pdf-line mr-2"></i>
                    GERAR PDF
                  </button>
                  
                  <button
                    onClick={() => navigate('/super-sete')}
                    className="w-full px-6 py-3 text-base font-medium bg-white/5 border border-white/10 rounded-xl hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-arrow-go-back-line mr-2"></i>
                    REFAZER APOSTA
                  </button>

                  <button
                    onClick={() => navigate('/gerar-apostas')}
                    className="w-full px-6 py-3 text-base font-medium bg-white/5 border border-white/10 rounded-xl hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-home-line mr-2"></i>
                    VOLTAR AO INÍCIO
                  </button>
                </div>
              </div>
            </div>

            {/* Right column - Selected numbers */}
            <div className="lg:col-span-2">
              <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6">
                <h3 className="text-xl font-bold mb-6">Números Selecionados</h3>
                
                <div className="grid grid-cols-7 gap-4 mb-6">
                  {Array.from({ length: 7 }, (_, colIndex) => (
                    <div key={colIndex} className="text-center">
                      <div className="bg-green-600 text-white font-bold text-lg rounded-lg p-2 mb-2">
                        C {colIndex + 1}
                      </div>
                      <div className="space-y-2">
                        {numbers[colIndex] && numbers[colIndex].length > 0 ? (
                          numbers[colIndex].map((num, idx) => (
                            <div
                              key={idx}
                              className="bg-gradient-to-br from-cyan-500 to-blue-600 text-white font-bold text-lg rounded-lg p-3"
                            >
                              {num.toString().padStart(2, '0')}
                            </div>
                          ))
                        ) : (
                          <div className="bg-gray-600 text-gray-300 text-center py-3 rounded-lg">
                            -
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>

                {/* Summary info */}
                <div className="bg-gray-800 rounded-lg p-4">
                  <div className="grid grid-cols-2 gap-4 text-sm">
                    <div>
                      <span className="text-gray-400">Aposta gerada em:</span>
                      <div className="font-mono">{new Date().toLocaleString('pt-BR')}</div>
                    </div>
                    <div>
                      <span className="text-gray-400">ID da geração:</span>
                      <div className="font-mono">#{generationId}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
